import { render, staticRenderFns } from "./feessummaries.vue?vue&type=template&id=452cbcd0&"
import script from "./feessummaries.vue?vue&type=script&lang=js&"
export * from "./feessummaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports